//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
export default {
  name: "WorkOpinionModal",
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: "意见评论表单",
      tableName: "om_work_opinion",
      form_fields: ['originId', 'originKey', 'opinion', 'parentId'],
      form_fields_time: [],
      validatorRules: {
        originId: {
          rules: [{
            required: true,
            message: '请输入来源id:评论的是那条数据!'
          }]
        },
        originKey: {
          rules: [{
            required: true,
            message: '请输入评论类型：反馈单；任务单等!'
          }]
        },
        opinion: {
          rules: [{
            required: true,
            message: '请输入具体意见!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {}
};